export namespace RankingQuery {
  export enum Span {
    all = "all",
    academic_year = "academic_year",
    month = "month",
  }
}
